const LLM_SCENE_TRUNK_CONFIG = {
  manualIp: '',
  testIp: '172.17.98.104:13000',
  prodIp: '172.17.98.109:13000',
}

function isLlmTrunkTestHostname() {
  if (typeof window === 'undefined') return false
  const h = String(window.location.hostname || '').toLowerCase()
  return h.includes('bj') || h.includes('localhost')
}

function pickLlmTrunkIp() {
  const manual = String(LLM_SCENE_TRUNK_CONFIG.manualIp || '').trim()
  if (manual) return manual
  return isLlmTrunkTestHostname()
    ? String(LLM_SCENE_TRUNK_CONFIG.testIp || '').trim()
    : String(LLM_SCENE_TRUNK_CONFIG.prodIp || '').trim()
}

function cloneJson(obj) {
  return JSON.parse(JSON.stringify(obj))
}

/** 调试前保证 flow 含 llm-omini，否则后端无法对大模型话术做 ASR/回复。 */
export function prepareDebugFlow(scene, sceneId) {
  const next = cloneJson(scene && typeof scene === 'object' ? scene : {})
  const sid = sceneId != null && sceneId !== '' ? Number(sceneId) : NaN
  const agentid = String(Number.isFinite(sid) ? sid : sceneId != null ? sceneId : '')
  const nameVal =
    next.name != null && String(next.name).trim() !== '' ? String(next.name).trim() : '双工大模型'
  const trunk_ip = pickLlmTrunkIp()

  if (!Array.isArray(next.scenes)) next.scenes = []
  let flow = next.scenes[0]
  if (!flow || typeof flow !== 'object') {
    flow = { id: 'F00001', name: '双工大模型', nodes: [] }
    next.scenes[0] = flow
  }
  if (!Array.isArray(flow.nodes)) flow.nodes = []

  const thirdBase = {
    id: 'L00001',
    type: 'llm-omini',
    name: nameVal,
    agentid,
    trunk_ip,
    tag: '',
    top: 200,
    left: 0,
  }

  const mergeNode = (prev) => {
    const keep = prev && typeof prev === 'object' ? cloneJson(prev) : {}
    return {
      ...thirdBase,
      ...keep,
      id: keep.id || thirdBase.id,
      type: 'llm-omini',
      name: keep.name || thirdBase.name,
      agentid: keep.agentid || thirdBase.agentid,
      trunk_ip: keep.trunk_ip || thirdBase.trunk_ip,
    }
  }

  const byLid = flow.nodes.findIndex((n) => n && n.type === 'llm-omini' && String(n.id) === 'L00001')
  const anyThird = flow.nodes.findIndex((n) => n && n.type === 'llm-omini')
  if (byLid >= 0) {
    flow.nodes[byLid] = mergeNode(flow.nodes[byLid])
  } else if (anyThird >= 0) {
    flow.nodes[anyThird] = mergeNode(flow.nodes[anyThird])
  } else {
    flow.nodes = [cloneJson(thirdBase), ...flow.nodes]
  }
  return next
}

export function pickOpeningText(scene, fallback, voiceCall) {
  const fromProp = fallback != null ? String(fallback).trim() : ''
  if (fromProp) return fromProp
  const cc = voiceCall && voiceCall.callControl
  const preset = cc && cc.preset_opening && cc.preset_opening.text != null
    ? String(cc.preset_opening.text).trim()
    : ''
  if (preset) return preset
  const ls = scene && scene.llmsettings && typeof scene.llmsettings === 'object' ? scene.llmsettings : {}
  if (ls.opening != null && String(ls.opening).trim()) return String(ls.opening).trim()
  const pc = ls.prompt_config && typeof ls.prompt_config === 'object' ? ls.prompt_config : {}
  const flow = Array.isArray(pc.business_flow) ? pc.business_flow : []
  for (let i = 0; i < flow.length; i += 1) {
    const row = flow[i]
    if (!row || typeof row !== 'object') continue
    const title = String(row.title || '').trim()
    const key = String(row.key || row.id || '').trim()
    if (title === '开场白' || title.toLowerCase() === 'opening' || key === 'opening') {
      const content = row.content != null ? String(row.content).trim() : ''
      if (content) return content
    }
  }
  return ''
}
